import React from "react";

// Images
import naranja from "./../../assets/img/naranja.svg";
import defaultImg from './../../assets/img/preloaders/main.jpg'

const MainInfo = props => (
  <section id="js-main-info" className="section main-info">
    <img className="naranja" src={naranja} alt=""/>
    <div className="container">
      <div className="columns is-vcentered">
        <div id="js-main-info-text" className="column is-10-tablet is-offset-1-tablet is-5-desktop main-info-content"
          data-aos="fade-right" data-aos-duration="500" data-aos-delay="100" data-aos-offset="300" data-aos-easing="ease-in-out-quad">
          <p>{props.lang === "es" ? props.apiHome.titulo_reservas_home : props.apiHome.titulo_reservas_home}</p>
          <a
            className="btn-brown"
            target="_blank"
            rel="noopener noreferrer"
            title={props.lang === "es" ? props.apiHome.botonMainInfo : props.apiHome.botonMainInfo}
            href={props.lang === "es" ? props.apiHome.texto_reservas_home : props.apiHome.texto_reservas_home}
          >
            {props.lang === "es" ? props.apiHome.texto_boton_reservas_home : props.apiHome.texto_boton_reservas_home}
          </a>
        </div>
        <div id="js-main-info-img" className="column is-10-tablet is-offset-1-tablet is-10-desktop is-offset-2-desktop"
          data-aos="fade-left" data-aos-duration="500" data-aos-delay="200" data-aos-offset="300" data-aos-easing="ease-in-out-quad"
        >
          <picture>
            <source srcSet={props.apiHome.bg_reservas_home ? props.apiHome.bg_reservas_home.sizes.xs : defaultImg} media="(max-width: 480px)" />
            <source srcSet={props.apiHome.bg_reservas_home ? props.apiHome.bg_reservas_home.sizes.sm : defaultImg} media="(max-width: 999px)" />
            <source srcSet={props.apiHome.bg_reservas_home ? props.apiHome.bg_reservas_home.sizes.md : defaultImg} media="(min-width: 1000px) and (max-width: 1191px)" />
            <img className="bcg" src={props.apiHome.bg_reservas_home ? props.apiHome.bg_reservas_home.sizes.md : defaultImg} alt="" />
          </picture>
        </div>
      </div>
    </div>
  </section>
);

export default MainInfo;
